var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddPeople(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 11,
    viewBox: "0 0 20 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66667 4.33329H4.16667V1.83329H2.5V4.33329H0V5.99996H2.5V8.49996H4.16667V5.99996H6.66667V4.33329ZM15 5.16663C16.3833 5.16663 17.4917 4.04996 17.4917 2.66663C17.4917 1.28329 16.3833 0.166626 15 0.166626C14.7333 0.166626 14.475 0.208293 14.2417 0.283293C14.7167 0.958293 14.9917 1.77496 14.9917 2.66663C14.9917 3.55829 14.7083 4.36663 14.2417 5.04996C14.475 5.12496 14.7333 5.16663 15 5.16663ZM10.8333 5.16663C12.2167 5.16663 13.325 4.04996 13.325 2.66663C13.325 1.28329 12.2167 0.166626 10.8333 0.166626C9.45 0.166626 8.33333 1.28329 8.33333 2.66663C8.33333 4.04996 9.45 5.16663 10.8333 5.16663ZM16.35 6.96663C17.0417 7.57496 17.5 8.34996 17.5 9.33329V11H20V9.33329C20 8.04996 18.025 7.25829 16.35 6.96663ZM10.8333 6.83329C9.16667 6.83329 5.83333 7.66663 5.83333 9.33329V11H15.8333V9.33329C15.8333 7.66663 12.5 6.83329 10.8333 6.83329Z",
    fill: "#B12D84"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddPeople);
export default __webpack_public_path__ + "static/media/addPeople.cd3fccf37b5181f914b7b2695fede6b6.svg";
export { ForwardRef as ReactComponent };